import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {UserComponent} from "./pages/user.component";
import {UserFormComponent} from "./pages/user-form/user-form.component";
import {UserRoutingModule} from "./user-routing.module";
import {MatIconModule} from "@angular/material/icon";
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {DataTableComponent} from "../../shared/data-table/data-table.component";
import {MatSort} from "@angular/material/sort";
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatCardModule} from "@angular/material/card";
import {MatInputModule} from "@angular/material/input";
import {ToastrModule} from "ngx-toastr";
import {MatDialogModule} from '@angular/material/dialog';
import {MatSelectModule} from "@angular/material/select";


@NgModule({
  declarations: [UserComponent, UserFormComponent, DataTableComponent],
  imports: [
    CommonModule,
    UserRoutingModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatSort,
    MatProgressBarModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    MatSelectModule,
    ToastrModule.forRoot()
  ],
})
export class UserModule {
}
